// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SwitcherTwoToneSvg from "@fishx/icons-svg/es/asn/SwitcherTwoTone";
import FishxIcon from '../components/FishxIcon';

var SwitcherTwoTone = function SwitcherTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SwitcherTwoToneSvg
  }));
};

SwitcherTwoTone.displayName = 'SwitcherTwoTone';
export default React.forwardRef(SwitcherTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SwitcherTwoTone.js
// module id = 4222
// module chunks = 0